export { countDiscountProductService }

function countDiscountProductService(price, user_discount, promocode_discount, product_discount) {
   
    // Check and apply promocode or discount
    let all_discounts = [ Number(user_discount), Number(promocode_discount), Number(product_discount) ];

    let max = Math.max.apply(null, all_discounts);
    // console.log(max);

    // Get item price without sales
    price = Number(price);
    
    // Set finaly item price
    let finaly_price = price * (100 - max) / 100;

    // // Get rounded
    // finaly_price = finaly_price.toFixed(2);

    return finaly_price;
}